import { useState } from 'react';
import { INITIAL_MESSAGE } from '../constants';

export const useChat = () => {
    const [conversationHistory, setConversationHistory] = useState([INITIAL_MESSAGE]);
    const [messages, setMessages] = useState([{
        id: 1,
        text: INITIAL_MESSAGE.content,
        sender: "bot",
        timestamp: new Date(),
        images: []
    }]);

    return {
        conversationHistory,
        setConversationHistory,
        messages,
        setMessages
    };
};